<div *ngIf="loaded" class="w-100 h-100 justify-content-center">
  <div [ngSwitch]="documentType" class="viewer-container h-100">
    <app-pdf-viewer *ngSwitchCase="'PDF'" [document]="document"></app-pdf-viewer>
    <app-image-viewer
      *ngSwitchCase="'Image'"
      [imgUrl]="imgUrl"
      (pageSelection)="loadPage($event)"
      [totalPages]="totalPages"
      class="w-100 h-100"
    ></app-image-viewer>
    <div *ngSwitchDefault>
      <div class="document-background d-flex align-items-center">
        <span class="text-center w-100">
          This file cannot be previewed using your browser.
          <button class="link" (click)="downloadClick()">Click here to download</button>
        </span>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!loaded" class="document-background d-flex align-items-center justify-content-center">
  <div id="loading"></div>
</div>
